import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import supportHtml from '@/marketing/support.html?raw';
import { prepareMarketingHtml, makeInternalLinkHandler } from '@/lib/marketing';

export default function Support() {
  const navigate = useNavigate();
  const html = useMemo(() => prepareMarketingHtml(supportHtml), []);
  const onClick = useMemo(() => makeInternalLinkHandler(navigate), [navigate]);

  useEffect(() => {
    document.title = 'Support — 18Gimmies';
  }, []);

  return <div onClick={onClick} dangerouslySetInnerHTML={{ __html: html }} />;
}
